import { render, staticRenderFns } from "./headMenu.vue?vue&type=template&id=bf23b8aa&scoped=true"
import script from "./headMenu.vue?vue&type=script&lang=js"
export * from "./headMenu.vue?vue&type=script&lang=js"
import style0 from "./headMenu.vue?vue&type=style&index=0&id=bf23b8aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf23b8aa",
  null
  
)

export default component.exports